// Sichtbar Gut Bewertet — Inhalte (ANWALTLICH GEPRÜFT, wortwörtlich erhalten).
// DE = Originaltext der Live-Site (unverändert). EN = sinngemäße Übersetzung.

export const sgb = {
  meta: {
    title: "Sichtbar Gut Bewertet — Deine digitale Wirkung. Klar sichtbar.",
    description:
      "Bewertungsmanagement, CLEAR SIGNAL™ Profilanalysen, Webseiten und Unterstützung bei Account-Sperrungen.",
  },

  nav: {
    home: { de: "Start", en: "Home" },
    reviews: { de: "Bewertungen", en: "Reviews" },
    clearsignal: { de: "CLEAR SIGNAL™", en: "CLEAR SIGNAL™" },
    accounts: { de: "Account-Sperrungen", en: "Account suspensions" },
    websites: { de: "Webseiten", en: "Websites" },
    faq: { de: "FAQ", en: "FAQ" },
    contact: { de: "Kontakt", en: "Contact" },
    langs: ["de", "en"],
  },

  hero: {
    eyebrow: { de: "EST. · Online-Reputation", en: "EST. · Online reputation" },
    title_top: { de: "Deine digitale Wirkung.", en: "Your digital presence." },
    title_bottom: { de: "Klar sichtbar.", en: "Clearly visible." },
    subline: {
      de: "Bewertungen · CLEAR SIGNAL™ Profilanalysen · Webseiten · Account-Wiederherstellung",
      en: "Reviews · CLEAR SIGNAL™ profile analysis · Websites · Account recovery",
    },
    cta_primary: { de: "Jetzt anfragen", en: "Send an inquiry" },
    cta_ghost: { de: "Leistungen ansehen", en: "Explore services" },
  },

  manifesto: {
    eyebrow: { de: "Manifest", en: "Manifesto" },
    body: [
      {
        de: "Menschen sehen nicht nur deinen Content.",
        en: "People don’t just see your content.",
      },
      {
        de: "Sie bewerten dein gesamtes Profil.",
        en: "They judge your entire profile.",
      },
      {
        de: "Vertrauen, Wirkung und Sichtbarkeit entstehen durch klare Signale.",
        en: "Trust, presence and visibility are built through clear signals.",
      },
      {
        de: "Dein Online-Auftritt entscheidet heute darüber, ob Menschen dir vertrauen, dich kontaktieren — oder weiterscrollen.",
        en: "Your online presence decides today whether people trust you, contact you — or scroll past.",
      },
    ],
    closing: {
      de: "Ich unterstütze Unternehmen, Creator und Personal Brands dabei, ihre digitale Außenwirkung gezielt zu stärken: durch professionelles Bewertungsmanagement, CLEAR SIGNAL™ Profilanalysen, die Wiederherstellung gesperrter Accounts sowie moderne Webseiten mit klarer Wirkung.",
      en: "I support companies, creators and personal brands in strengthening their digital presence — through professional review management, CLEAR SIGNAL™ profile analysis, recovery of suspended accounts and modern websites with clear impact.",
    },
  },

  services_overview: [
    {
      n: "01",
      key: "reviews",
      name: { de: "Bewertungen", en: "Reviews" },
      body: {
        de: "Google & Trustpilot – negative, falsche oder unfaire Bewertungen professionell prüfen und gezielt angehen.",
        en: "Google & Trustpilot — review negative, false or unfair reviews professionally and take focused action.",
      },
    },
    {
      n: "02",
      key: "clearsignal",
      name: { de: "Profilanalyse", en: "Profile analysis" },
      body: {
        de: "CLEAR SIGNAL™ – KI-gestützte Profilanalyse für TikTok, Instagram & Facebook zur Analyse deiner Sichtbarkeit, Wirkung und Außenwirkung.",
        en: "CLEAR SIGNAL™ — AI-supported profile analysis for TikTok, Instagram & Facebook to analyse your visibility, impact and outward presence.",
      },
    },
    {
      n: "03",
      key: "websites",
      name: { de: "Webseiten", en: "Websites" },
      body: {
        de: "Moderne Webseiten mit klarer Struktur, starker Wirkung und professioneller Außenwirkung – passend zu deiner Marke und deinen Zielen.",
        en: "Modern websites with clear structure, strong presence and professional outward feel — matched to your brand and your goals.",
      },
    },
    {
      n: "04",
      key: "accounts",
      name: { de: "Account-Sperrungen", en: "Account suspensions" },
      body: {
        de: "TikTok, Instagram & Co. – Unterstützung beim offiziellen DSA-Verfahren zur Prüfung und Wiederherstellung gesperrter Accounts.",
        en: "TikTok, Instagram & co. — support with the official DSA procedure to review and restore suspended accounts.",
      },
    },
  ],

  reviews: {
    eyebrow: { de: "01 · Onlinebewertungen", en: "01 · Online reviews" },
    title: {
      de: "Professionelles Bewertungsmanagement für Google & Trustpilot",
      en: "Professional review management for Google & Trustpilot",
    },
    body: {
      de: "Unterstützung bei der strukturierten Einreichung von Bewertungsprüfungen über die offiziellen Meldeverfahren der Plattformen.",
      en: "Support with the structured submission of review checks via the platforms’ official reporting procedures.",
    },
    process_title: { de: "So funktioniert es", en: "How it works" },
    steps: [
      {
        n: "01",
        title: { de: "Anfrage stellen", en: "Make an inquiry" },
        body: {
          de: "Wir besprechen die betreffenden Bewertungen & du erhältst ein kostenloses Angebot.",
          en: "We discuss the reviews in question & you receive a free quote.",
        },
      },
      {
        n: "02",
        title: { de: "Einreichung", en: "Submission" },
        body: {
          de: "Die Bewertung wird strukturiert geprüft und über das offizielle Verfahren eingereicht.",
          en: "The review is checked in a structured way and submitted via the official procedure.",
        },
      },
      {
        n: "03",
        title: { de: "Die Plattform entscheidet", en: "The platform decides" },
        body: {
          de: "Die finale Entscheidung liegt beim Plattformbetreiber.",
          en: "The final decision rests with the platform operator.",
        },
      },
    ],
    prices_title: { de: "Preise · klar & transparent", en: "Pricing · clear & transparent" },
    prices: [
      {
        price: "57,-€",
        suffix: null,
        name: { de: "Einzelbewertung", en: "Single review" },
        body: {
          de: "Strukturierte Aufbereitung und Einreichung gemäß Plattform-Richtlinien. Festpreis.",
          en: "Structured preparation and submission according to platform guidelines. Fixed price.",
        },
        tag: null,
      },
      {
        price: "47,-€",
        suffix: { de: "pro Bewertung", en: "per review" },
        name: { de: "2–9 Bewertungen", en: "2–9 reviews" },
        body: {
          de: "Einreichung je Bewertung gemäß Plattform-Vorgaben. Dokumentiert und nachvollziehbar.",
          en: "Submission per review according to platform requirements. Documented and traceable.",
        },
        tag: { de: "Beliebteste Option", en: "Most popular" },
      },
      {
        price: { de: "auf Anfrage", en: "on request" },
        suffix: { de: "pro Bewertung", en: "per review" },
        name: { de: "ab 10 Bewertungen", en: "from 10 reviews" },
        body: {
          de: "Gebündelte, strukturierte Einreichung mehrerer Bewertungen.",
          en: "Bundled, structured submission of multiple reviews.",
        },
        tag: null,
      },
    ],
    cta: { de: "Jetzt anfragen", en: "Send an inquiry" },
  },

  clearsignal: {
    eyebrow: { de: "02 · CLEAR SIGNAL™", en: "02 · CLEAR SIGNAL™" },
    title: {
      de: "Dein Social Media Profil wird analysiert. Deine Strategie wird klar.",
      en: "Your social media profile gets analysed. Your strategy becomes clear.",
    },
    body: {
      de: "CLEAR SIGNAL™ analysiert die Signale, die Menschen und Plattformen über dich wahrnehmen — von Vertrauen und Sichtbarkeit bis hin zu Reichweite, Wirkung und Wachstum.",
      en: "CLEAR SIGNAL™ analyses the signals people and platforms perceive about you — from trust and visibility to reach, impact and growth.",
    },
    sub: {
      de: "KI-gestützte Profilanalyse für Instagram, TikTok & Facebook",
      en: "AI-supported profile analysis for Instagram, TikTok & Facebook",
    },
    packages_title: { de: "CLEAR SIGNAL™ PAKETE", en: "CLEAR SIGNAL™ PACKAGES" },
    packages_available: {
      de: "Verfügbar für · Instagram · TikTok · Facebook",
      en: "Available for · Instagram · TikTok · Facebook",
    },
    packages: [
      {
        name: "Focus",
        price: "49,-€",
        body: { de: "Eine Plattform", en: "One platform" },
        tag: null,
      },
      {
        name: "Pro",
        price: "119,-€",
        body: { de: "3 Plattformen", en: "3 platforms" },
        tag: null,
      },
      {
        name: "Premium",
        price: "279,-€",
        body: { de: "3 Plattformen + 45 Min. Strategy Call", en: "3 platforms + 45 min strategy call" },
        tag: { de: "Beratung inklusive", en: "Consult included" },
      },
    ],
    note: {
      de: "Du fragst dich, welches Paket das richtige für dich ist? Schreib mir direkt — ich berate dich gerne persönlich. 📩",
      en: "Not sure which package fits? Write to me directly — happy to advise you personally. 📩",
    },
    handle: { label: "Instagram", value: "@patrice.digital", href: "https://instagram.com/patrice.digital" },

    // Akronym-Block: CLEAR + SIGNAL — buchstabiert die Methodologie
    acronym: {
      eyebrow: { de: "— Was CLEAR SIGNAL™ wirklich bedeutet", en: "— What CLEAR SIGNAL™ really stands for" },
      // Group 1: CLEAR — 5 words
      clear: [
        { letter: "C", word: { de: "CONTENT", en: "CONTENT" } },
        { letter: "L", word: { de: "LEADMAGNET", en: "LEADMAGNET" } },
        { letter: "E", word: { de: "ENGAGEMENT", en: "ENGAGEMENT" } },
        { letter: "A", word: { de: "ALGORITHMUS", en: "ALGORITHM" } },
        { letter: "R", word: { de: "RESONANZ", en: "RESONANCE" } },
      ],
      // Group 2: SIGNAL — 6 words
      signal: [
        { letter: "S", word: { de: "SICHTBAR", en: "SEEN" } },
        { letter: "I", word: { de: "INSPIRIEREND", en: "INSPIRING" } },
        { letter: "G", word: { de: "GLAUBWÜRDIG", en: "GENUINE" } },
        { letter: "N", word: { de: "NAHBAR", en: "NEAR" } },
        { letter: "A", word: { de: "ANZIEHEND", en: "ATTRACTIVE" } },
        { letter: "L", word: { de: "LOYAL", en: "LOYAL" } },
      ],
    },

    // 2-Spalten Nutzen-Tabelle: was analysiert wird und was du davon hast
    benefits: {
      title: {
        de: "Was analysiert wird — und was du davon hast.",
        en: "What gets analysed — and what you take away.",
      },
      items: [
        { left: { de: "Content", en: "Content" },         right: { de: "Du weißt, was wirklich ankommt.",                en: "You know what truly lands." } },
        { left: { de: "Leadmagnet", en: "Leadmagnet" },   right: { de: "Du gewinnst die richtigen Kontakte.",           en: "You win the right contacts." } },
        { left: { de: "Engagement", en: "Engagement" },   right: { de: "Du verstehst, warum manche Posts performen.",   en: "You understand why some posts perform." } },
        { left: { de: "Algorithmus", en: "Algorithm" },   right: { de: "Du arbeitest mit ihm — nicht gegen ihn.",       en: "You work with it — not against it." } },
        { left: { de: "Resonanz", en: "Resonance" },      right: { de: "Du weißt, wie du wirklich wahrgenommen wirst.", en: "You know how you are truly perceived." } },
        { left: { de: "Sichtbar", en: "Visible" },        right: { de: "Du wirst gefunden — von den Richtigen.",        en: "You get found — by the right people." } },
        { left: { de: "Inspirierend", en: "Inspiring" },  right: { de: "Dein Profil hinterlässt einen Eindruck.",       en: "Your profile leaves an impression." } },
        { left: { de: "Glaubwürdig", en: "Genuine" },     right: { de: "Du baust Vertrauen auf — nachhaltig.",          en: "You build trust — sustainably." } },
        { left: { de: "Nahbar", en: "Near" },             right: { de: "Menschen folgen dir, weil sie dich mögen.",      en: "People follow you because they like you." } },
        { left: { de: "Anziehend", en: "Attractive" },    right: { de: "Du ziehst die Richtigen an — ohne laut zu sein.", en: "You attract the right ones — without being loud." } },
        { left: { de: "Loyal", en: "Loyal" },             right: { de: "Aus Followern werden echte Fans.",              en: "Followers turn into true fans." } },
      ],
    },

    // Instagram Profil-Link (kompakt, kein Bild)
    instagram: {
      eyebrow: { de: "— Folge dem Signal", en: "— Follow the signal" },
      handle: "@patrice.digital",
      tagline: {
        de: "Einblicke, Gedanken, Beispiele — direkt aus der Praxis.",
        en: "Insights, thoughts, examples — straight from practice.",
      },
      cta: { de: "Auf Instagram ansehen", en: "View on Instagram" },
      href: "https://instagram.com/patrice.digital",
    },
  },

  accounts: {
    eyebrow: { de: "04 · ACCOUNT-SPERRUNGEN", en: "04 · ACCOUNT SUSPENSIONS" },
    title: {
      de: "Account gesperrt? Das muss nicht das Ende sein.",
      en: "Account suspended? That doesn’t have to be the end.",
    },
    body: {
      de: "TikTok weg. Instagram dicht. Und niemand erklärt dir warum.",
      en: "TikTok gone. Instagram shut. And no one explains why.",
    },
    body2: {
      de: "Ich begleite dich durch den offiziellen DSA-Prozess — strukturiert, diskret und nachvollziehbar. Account-Sperrungen auf TikTok, Instagram & weiteren Plattformen. Unterstützung bei offiziellen DSA-Verfahren.",
      en: "I guide you through the official DSA process — structured, discreet and traceable. Account suspensions on TikTok, Instagram and other platforms. Support with official DSA procedures.",
    },
    cta: { de: "Jetzt anfragen", en: "Send an inquiry" },
  },

  websites: {
    eyebrow: { de: "03 · WEBSEITEN", en: "03 · WEBSITES" },
    title_top: { de: "Webseiten, die Vertrauen aufbauen.", en: "Websites that build trust." },
    title_bottom: { de: "Klar gestaltet — für echte Anfragen.", en: "Clearly designed — for real inquiries." },
    audiences: [
      {
        n: "01",
        name: { de: "Unternehmen", en: "Companies" },
        body: { de: "Praxen · Studios · Dienstleister", en: "Practices · studios · service providers" },
      },
      {
        n: "02",
        name: { de: "Personal Brands", en: "Personal brands" },
        body: { de: "Coaches · Expert:innen · Creator", en: "Coaches · experts · creators" },
      },
      {
        n: "03",
        name: { de: "Lokal", en: "Local" },
        body: { de: "Salons · Restaurants · Handwerk", en: "Salons · restaurants · craft" },
      },
    ],
    types: [
      {
        name: { de: "One Page Website", en: "One-page website" },
        body: {
          de: "Eine klare, moderne Website mit Fokus auf Sichtbarkeit, Vertrauen und Anfragen.",
          en: "A clear, modern website focused on visibility, trust and inquiries.",
        },
      },
      {
        name: { de: "Mehrseitige Website", en: "Multi-page website" },
        body: {
          de: "Professioneller Webauftritt für Unternehmen, Marken und Dienstleistungen mit mehreren Bereichen.",
          en: "Professional web presence for companies, brands and services with multiple sections.",
        },
      },
    ],
    process_title: { de: "Mein Prozess", en: "My process" },
    steps: [
      { n: "01", title: { de: "Strategie", en: "Strategy" }, body: { de: "Ziel, Positionierung & Struktur.", en: "Goal, positioning & structure." } },
      { n: "02", title: { de: "Aufbau", en: "Build" }, body: { de: "Design, Inhalte & Seitenstruktur.", en: "Design, content & site structure." } },
      { n: "03", title: { de: "Feinschliff", en: "Refinement" }, body: { de: "Optimierung bis alles stimmig wirkt.", en: "Optimisation until everything feels right." } },
      { n: "04", title: { de: "Launch", en: "Launch" }, body: { de: "Livegang & Übergabe.", en: "Go-live & handover." } },
    ],
    cta: { de: "Jetzt anfragen", en: "Send an inquiry" },
  },

  faq: {
    title: { de: "Häufig gestellte Fragen", en: "Frequently asked questions" },
    items: [
      {
        q: { de: "Wird eine Entfernung garantiert?", en: "Is removal guaranteed?" },
        a: {
          de: "Nein. Ich biete keine Erfolgsgarantie. Die Entscheidung liegt allein beim Plattformbetreiber. Die Vergütung wird für den erbrachten administrativen Aufwand fällig, unabhängig von der Entscheidung der Plattform.",
          en: "No. I offer no guarantee of success. The decision rests solely with the platform operator. Payment is due for the administrative work performed, regardless of the platform’s decision.",
        },
      },
      {
        q: { de: "Ist das eine Rechtsberatung?", en: "Is this legal advice?" },
        a: {
          de: "Ausdrücklich nein. Ich biete eine administrative und organisatorische Unterstützungsdienstleistung. Ich nutze ausschließlich die offiziellen Meldeverfahren der Plattformen.",
          en: "Explicitly no. I provide an administrative and organisational support service. I exclusively use the platforms’ official reporting procedures.",
        },
      },
      {
        q: { de: "Wie lange dauert der Prozess?", en: "How long does the process take?" },
        a: {
          de: "Ich reiche deinen Antrag innerhalb eines Werktages ein. Die Bearbeitungszeit durch die Plattform variiert und liegt außerhalb meiner Kontrolle.",
          en: "I file your request within one business day. Processing time at the platform varies and is outside my control.",
        },
      },
      {
        q: { de: "Was kostet der Service?", en: "What does the service cost?" },
        a: {
          de: "Die Vergütung wird für den erbrachten administrativen Aufwand fällig, nicht für einen bestimmten Erfolg. Alle Preise sind transparent aufgeführt. Kontaktiere mich für ein kostenloses Erstgespräch.",
          en: "Payment is for the administrative work performed, not for a specific outcome. All prices are listed transparently. Contact me for a free introductory call.",
        },
      },
    ],
  },

  disclaimer: {
    label: { de: "Hinweis", en: "Notice" },
    summary: {
      de: "Umfang der Dienstleistung & rechtlicher Rahmen",
      en: "Scope of service & legal framework",
    },
    body: {
      de: "Die Dienstleistung umfasst das professionelle Management von Online-Bewertungen. Ich unterstütze administrativ und organisatorisch bei der Einreichung von Anträgen zur Überprüfung von Bewertungen auf externen Plattformen. Ich biete ausdrücklich keine Rechtsberatung an. Die Tätigkeit beschränkt sich auf die Nutzung der von den Plattformbetreibern zur Verfügung gestellten Meldeverfahren auf Basis deren eigener Richtlinien. Ein Erfolg, insbesondere die Änderung oder Löschung einer Bewertung, wird nicht garantiert, da die Entscheidung allein beim Plattformbetreiber liegt.",
      en: "The service covers the professional management of online reviews. I provide administrative and organisational support in submitting requests to have reviews checked on external platforms. I expressly do not offer legal advice. The activity is limited to using the reporting procedures provided by the platform operators on the basis of their own guidelines. Success, in particular the modification or deletion of a review, is not guaranteed, as the decision rests solely with the platform operator.",
    },
  },

  pricingNote: {
    label: { de: "Preise & Zahlung", en: "Pricing & payment" },
    payment: {
      de: "Die Zahlung erfolgt bei Beauftragung, vor der Einreichung der Meldung. Keine laufenden Kosten, keine Abonnements, keine versteckten Gebühren. Die unverbindliche Vorab-Rückmeldung ist immer kostenfrei.",
      en: "Payment is due upon engagement, before the report is submitted. No recurring costs, no subscriptions, no hidden fees. The non-binding initial response is always free.",
    },
    vat: {
      de: "Alle angegebenen Preise sind Endpreise zuzüglich Liefer-/Versandkosten. Es erfolgt kein Ausweis der Umsatzsteuer aufgrund der Anwendung der Kleinunternehmerregelung gemäß § 19 UStG.",
      en: "All listed prices are end prices plus any delivery/shipping costs. VAT is not shown due to the small-business regulation under § 19 UStG (German VAT Act).",
    },
  },

  contact: {
    eyebrow: { de: "Kontakt", en: "Contact" },
    title: { de: "Schreib mir", en: "Write to me" },
    lede: {
      de: "Sag mir kurz, worum es geht – alles weitere besprechen wir.",
      en: "Tell me briefly what it's about — we'll discuss the rest together.",
    },
    name: { de: "Dein Name", en: "Your name" },
    email: { de: "E-Mail", en: "Email" },
    topic_label: { de: "Thema", en: "Topic" },
    topic_options: [
      { de: "Bewertungen", en: "Reviews" },
      { de: "CLEAR SIGNAL™", en: "CLEAR SIGNAL™" },
      { de: "Account-Sperrungen", en: "Account suspensions" },
      { de: "Webseiten", en: "Websites" },
      { de: "Etwas anderes", en: "Something else" },
    ],
    message: { de: "Deine Nachricht", en: "Your message" },
    submit: { de: "Nachricht senden", en: "Send message" },
    success: { de: "Vielen Dank für deine Nachricht. ✨ Du erhältst in Kürze eine Bestätigung in deinem Posteingang.", en: "Thank you for your message. ✨ A confirmation is on its way to your inbox." },
    error: { de: "Etwas ist schiefgelaufen. Bitte versuche es erneut.", en: "Something went wrong. Please try again." },
  },

  ribbons: {
    reviews: {
      whisper: { de: "Direkt anfragen – ich antworte persönlich.", en: "Reach out directly – I reply personally." },
      cta: { de: "Jetzt anfragen", en: "Get in touch" },
      scope: "Bewertungen",
    },
    clearsignal: {
      whisper: { de: "Direkt anfragen – ich antworte persönlich.", en: "Reach out directly – I reply personally." },
      cta: { de: "Jetzt anfragen", en: "Get in touch" },
      scope: "CLEAR SIGNAL™",
    },
  },

  footer: {
    legal: [
      { name: { de: "Impressum", en: "Imprint" }, href: "/sgb/impressum" },
      { name: { de: "Datenschutz", en: "Privacy" }, href: "/sgb/datenschutz" },
      { name: { de: "AGB", en: "Terms" }, href: "/sgb/agb" },
      { name: { de: "Widerrufsbelehrung & Widerrufsformular", en: "Right of withdrawal" }, href: "/sgb/widerruf" },
    ],
    copyright: { de: "© 2026 Sichtbar Gut Bewertet", en: "© 2026 Sichtbar Gut Bewertet" },
    line: { de: "Eine Spezialisierung von patrice.studio", en: "A specialisation of patrice.studio" },
  },
};
